"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var BIG_DATA_FLAG = Symbol('__BIG_DATA__');
var BigData = (function () {
    function BigData(options) {
        this.options = __assign({}, options);
    }
    BigData.prototype.create = function (data) {
        if (data !== undefined) {
            if (!data[BIG_DATA_FLAG]) {
                data[BIG_DATA_FLAG] = this.options;
            }
        }
        return data;
    };
    BigData.isBigData = function (data) {
        return data && !!data[BIG_DATA_FLAG];
    };
    BigData.compare = function (a, b) {
        if (BigData.isBigData(a) && BigData.isBigData(b)) {
            if (a[BIG_DATA_FLAG] === b[BIG_DATA_FLAG]) {
                return types_1.isFn(a[BIG_DATA_FLAG].compare)
                    ? a[BIG_DATA_FLAG].compare(a, b)
                    : a === b;
            }
            return false;
        }
        return a === b;
    };
    BigData.clone = function (value) {
        if (BigData.isBigData(value)) {
            if (types_1.isFn(value[BIG_DATA_FLAG].clone)) {
                var ctx = value[BIG_DATA_FLAG];
                var result = value[BIG_DATA_FLAG].clone(value);
                result[BIG_DATA_FLAG] = ctx;
                return result;
            }
        }
        return value;
    };
    return BigData;
}());
exports.BigData = BigData;
